import { DeleteButton } from '@/components/Elements/Button'
import { InputCell, RawTextCell } from '@/components/Table/components/Cell'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'
import { Flex } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'

const getFrameAgreementTableColumns = () => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.display({
      id: 'action',
      size: 200,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ row: { original } }) => {
        return (
          <Flex w="100%" alignItems={'center'}>
            {/* {original?.status === ListStatus.ACTIVE && (
              <>
                <Flex _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="100px">
                  <MdDeleteOutline
                    size={24}
                    onClick={(e) => {
                      e.stopPropagation()
                      handleToggle(original._id)
                    }}
                  />
                </Flex>
                <Button
                  colorScheme="teal"
                  onClick={(e) => {
                    e.stopPropagation()

                    handleAddProfileToAllUsers(original._id)
                  }}
                >
                  Add to all users
                </Button>
              </>
            )}
            {original?.status === ListStatus.INACTIVE && (
              <Flex _hover={{ cursor: 'pointer' }} color="green.400" justifyContent={'center'} w="100px">
                <MdOutlineCheckCircle
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleToggle(original._id)
                  }}
                />
              </Flex>
            )} */}
          </Flex>
        )
      },
    }),

    columnHelper.accessor('name', {
      cell: RawTextCell,
    }),
  ]
}

export const getFrameAgreementDetailTableColumns = ({ handleRemoveRow = () => {} }) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.display({
      id: 'action',
      size: 81,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ getValue, row: { original, index }, table, extraDisable = false }) => {
        const value = getValue()
        const isDisabled = table.options.meta?.disabled || extraDisable

        if (isDisabled) {
          return <></>
        }

        return <DeleteButton onClick={() => handleRemoveRow(index)} />
      },
    }),
    columnHelper.accessor('description', {
      size: 300,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('unit', {
      size: 81,
      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('rate', {
      size: 100,

      header: () => <>Rate for Typical floor</>,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('discountRate_1', {
      header: () => <span>Discount Rate Over 10 lot</span>,
      size: 81,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('discountRate_2', {
      header: () => <span>Discount Rate Over 50 lot</span>,
      size: 81,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('discountRate_3', {
      header: () => <span>Discount Rate Over 100 lot</span>,
      size: 81,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('remark', {
      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
  ]
}

export default getFrameAgreementTableColumns
